


























import {Component, Vue, Mixins} from "vue-property-decorator";
import ConfigMixin from "@/mixins/ConfigMixin";
import TestimonialOutput from "@/components/TestimonialOutput.vue";
import ServiceOutput from "@/components/ServiceOutput.vue";
import ContactForm from "@/components/ContactForm.vue";

@Component({
    name: "Home",
    components: {
        TestimonialOutput,
        ServiceOutput,
        ContactForm
    }
})
export default class Home extends Mixins(ConfigMixin) {
    private initialized = true;
}
